var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper noPadding" }, [
    _c(
      "div",
      { staticClass: "container-fluid oldInfluencerViewContainer mt-0" },
      [
        _vm.editMode
          ? _c(
              "div",
              {
                key: "editModeImage",
                staticClass: "row oldInfluencerBannerContainer",
                staticStyle: {
                  "max-width": "1200px",
                  "max-height": "480px",
                  overflow: "hidden"
                },
                attrs: { id: "demo" }
              },
              [
                _c("img", {
                  staticClass: "oldInfluencerBannerImage",
                  attrs: { src: _vm.getImage("edit"), alt: "" }
                })
              ]
            )
          : _c(
              "div",
              {
                key: "noEditModeImage",
                staticClass: "row oldInfluencerBannerContainer"
              },
              [
                _c("img", {
                  staticClass: "oldInfluencerBannerImage",
                  attrs: { src: _vm.getImage("noedit"), alt: "" }
                }),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "roundPencilContainer",
                    attrs: { href: "" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        _vm.$bus.$emit("activateProfileBannerEditor")
                      }
                    }
                  },
                  [_c("i", { staticClass: "fa fa-pencil" })]
                )
              ]
            )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-29b3bc10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29b3bc10","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileBanner.vue
// module id = 512
// module chunks = 2